import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { Round } from '../../../functions/Maths';
import Warning from '@material-ui/icons/Warning';

// eslint-disable-next-line
import style from './_styles.css';


function incrementoPorcentual(nuevo, anterior) {
    const n = nuevo ? parseInt(nuevo, 10) : 0;
    const a = anterior ? parseInt(anterior, 10) : 0;
    return Math.round(((n - a) / a) * 100 * 100) / 100;
}

class ForecastWidget extends Component {
    state = {
        desviacion: {},
        abierto: true
    };

    static getDerivedStateFromProps(props, state) {
        const { xef } = props;
        if (xef !== state.xef) {
            state.xef = xef;
            state.desviacion = xef && xef.desviacion ? xef.desviacion : {};
            state.abierto = xef && xef.desviacion ? xef.desviacion.abierto : false;
            return state;
        }
        return null;
    }

    handleLaunchForecast = () => {
        const { abierto } = this.state;
        if (abierto) {
            this.props
                .postForecast(this.props.id)
                .then((r) => {
                    if (r.error) {
                        this.props.onError(r.error.message);
                    } else if (r && r.codigo) {
                        this.props.history.push(`/xef/forecast/${r.codigo}/${this.props.id}`);
                    } else {
                        this.props.onClose(true);
                    }
                })
                .catch((error) => this.props.onError(error.message));
        }
    }


    render() {
        const { desviacion, abierto } = this.state;
        return (
            <div id="xhef" className="flex_full_column boxShadow bg_white margin_bottom_12 padding_top_6 padding_bottom_12 padding_left_6 padding_right_6 ">
                <div className="flex_full_row align_center">
                    <div className="flex_full_row barlow_regular_little c_slate nowrap">
                        <FormattedMessage id="current_forecast" />
                        <b>{' ' + desviacion.hora}</b>
                    </div>
                    <div className="flex_auto_row barlow_regular_title c_lipstick nowrap">
                        {(desviacion.horaReal && desviacion.horaPrevisto) ? incrementoPorcentual(desviacion.horaReal, desviacion.horaPrevisto) + ' %' : '- %'}
                    </div>
                </div>
                <div className="flex_full_column c_slate bg_cloudy_blue padding_top_6 padding_bottom_12 padding_left_6 padding_right_6  margin_bottom_12">
                    <div className="flex_full_row barlow_italic_small center margin_bottom_5">
                        <div className="flex_full_row center">
                            <FormattedMessage id="production_total_card_initial" />
                        </div>
                        <div className="flex_full_row center">
                            <FormattedMessage id="real" />
                        </div>
                    </div>
                    <div className="flex_full_row center barlow_regular_smalltext c_greyish_brown">
                        <div className="flex_full_row center">
                            {Round(desviacion.horaPrevisto) + ' €'}
                        </div>
                        <div className="flex_full_row center">
                            {Round(desviacion.horaReal) + ' €'}
                        </div>
                    </div>
                </div>
                {desviacion.alertaDesviacion &&
                    <div className="flex_auto_row margin_bottom_5 margin_top_6">
                        <Warning className="c_golden_yellow margin_right_12" />
                        <div onClick={this.handleLaunchForecast}
                            className={"flex_full_row  center barlow_regular_smalltext hand border_radius_6 " + (abierto ? "border_lipstick c_lipstick " : "border_disabled c_disabled")}>
                            <FormattedMessage id="production_total_card_change_forecast" />
                        </div>
                    </div>
                }
                <div className="flex_full_row align_center">
                    <div className="flex_full_row barlow_regular_little c_slate">
                        <FormattedMessage id="final_forecast" />
                    </div>
                    <div className="flex_auto_row barlow_regular_title c_lipstick nowrap">
                        {(desviacion.finPrevisto && desviacion.finReal) ? incrementoPorcentual(desviacion.finReal, desviacion.finPrevisto) + ' %' : 'NaN %'}
                    </div>
                </div>
                <div className="flex_full_column  c_slate bg_cloudy_blue padding_top_6 padding_bottom_12 padding_left_6 padding_right_6 ">
                    <div className="flex_full_row barlow_italic_small center margin_bottom_5">
                        <div className="flex_full_row center">
                            <FormattedMessage id="production_total_card_initial" />
                        </div>
                        <div className="flex_full_row center">
                            <FormattedMessage id="modification_forecast_new" />
                        </div>
                    </div>
                    <div className="flex_full_row center barlow_regular_smalltext c_greyish_brown">
                        <div className="flex_full_row center">
                            {Round(desviacion.finPrevisto) + ' €'}
                        </div>
                        <div className="flex_full_row center">
                            {Round(desviacion.finReal) + ' €'}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default ForecastWidget;



// WEBPACK FOOTER //
// ./src/components/complex/xhef/ForecastWidget.js